import Button from "@components/Button";
import CustomInput from "@components/CustomInput/CustomInput";
import styles from "./ResetPassword.module.css";
import { Link } from "react-router-dom";
import useAuth from "@hooks/useAuth";
import { useState } from "react";

const ResetPassword = ({ token, email }) => {
  const { handleResetPassword } = useAuth();
  const [passwordDetails, setPasswordDetails] = useState({
    password: "",
    confirmPassword: "",
  });

  const handleClick = () => {
    handleResetPassword({ password: passwordDetails?.password, token, email });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPasswordDetails({ ...passwordDetails, [name]: value });
  };

  return (
    <div className={styles.Wrapper}>
      <CustomInput
        type="password"
        showLabel
        label={"Password"}
        name="password"
        onChange={handleInputChange}
      />
      <CustomInput
        type="password"
        showLabel
        label={"Confirm Password"}
        name="confirmPassword"
        onChange={handleInputChange}
      />

      <Button
        btnType={"primary"}
        text={"Reset Password"}
        className={styles.SendBtn}
        onClick={handleClick}
      />
      <Link to="/signin" className={styles.SignIn}>
        Sign in instead
      </Link>
    </div>
  );
};

export default ResetPassword;
